import { defineMessages } from 'react-intl';

export const i18n: {
	aiGenerationErrorFlagDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	aiGenerationErrorFlagDescriptionWithReason: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	aiGenerationErrorFlagTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	imageLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titlePlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	titleLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-title-label',
		defaultMessage: 'Title',
		description: 'Label for title input for configuring Spotlight extension',
	},
	descriptionLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-description-label',
		defaultMessage: 'Description',
		description: 'Label for description input for configuring Spotlight extension',
	},
	imageLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-image-label',
		defaultMessage: 'Image',
		description:
			'Label for image button that opens a popup for media picker for configuring Spotlight extension',
	},
	titlePlaceholder: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder',
		defaultMessage: 'Give your spotlight a title',
		description: 'Input placeholder text for configuring Spotlight extension title',
	},
	descriptionPlaceholder: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder',
		defaultMessage:
			'Spotlights highlight important messages for your team. Design your spotlight with an image, your custom colors, a short description, and a link.',
		description: 'Input placeholder text for configuring Spotlight extension description',
	},
	aiGenerationErrorFlagTitle: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.title',
		defaultMessage: "We couldn't generate your image",
		description:
			'Title within the error flag when AI image generation fails for a Spotlight Company Hub premium extension.',
	},
	aiGenerationErrorFlagDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.description',
		defaultMessage: 'Try again or choose a different image.',
		description:
			'Description within the error flag when AI image generation fails for a Spotlight Company Hub premium extension.',
	},
	aiGenerationErrorFlagDescriptionWithReason: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.ai-generation.error.flag.description-with-reason',
		defaultMessage: '{errorReason}. Try again or choose a different image.',
		description:
			'Description within the error flag when AI image generation fails for a Spotlight Company Hub premium extension with a specific error reason from the API.',
	},
});
